module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/covid19/pc/btn_apple-52695deb4eb9544d55e6a21324ef96a7.png";